// ----------------------------------------------------------------------------
// Template: Cart
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

//Scripts
import 'snippets/cart-dropdown/cart-dropdown';
import 'snippets/cart/cart';
import 'sections/header/header';
import 'sections/main-cart/main-cart';
import 'sections/footer/footer';